import React from 'react';
import styled from 'styled-components';
import {COLORS} from '../../../constants/colors';
import {Checkbox} from '../../atoms/Checkbox/Checkbox';

export const SizeCheckboxList: React.FC<{
  sizes: Array<{
    sizeId: number;
    label: string;
  }>;
  selectedSizeIds: number[];
  onSizeSelect: (id: number) => void;
  label?: string;
}> = ({sizes, selectedSizeIds, onSizeSelect}) => {
  return (
    <>
      {sizes.map(size => {
        return (
          <SizeListItem
            key={size.sizeId}
            data-is-selected={selectedSizeIds.some(id => id === size.sizeId)}
          >
            <StyledCheckbox
              checked={selectedSizeIds.some(id => id === size.sizeId)}
              label={size.label}
              onChange={() => onSizeSelect(size.sizeId)}
            />
          </SizeListItem>
        );
      })}
    </>
  );
};

const SizeListItem = styled.li`
  border-bottom: none;
  :first-child {
    border-radius: 2px 2px 0 0;
  }
  :last-child {
    border-radius: 0 0 2px 2px;
    border-bottom: solid 1px ${COLORS.Grey3};
  }

  transition: background-color 0.2s ease-in-out;
  &:hover {
    cursor: pointer;
    background-color: ${COLORS.Grey4};
  }
  &[data-is-selected='true'] {
    background-color: ${COLORS.Grey5};
  }
`;

const StyledCheckbox = styled(Checkbox)`
  padding: 12px 20px;
  color: ${COLORS.Black};
  cursor: pointer;
`;
